module.exports = __webpack_public_path__ + "img/login.ad4b6529.svg";